module.exports = __webpack_public_path__ + "static/media/water-polo.829d6edc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-backgrounds/water-polo.jpg
// module id = 699
// module chunks = 0